/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { iocContainer, TYPES } from '@/engine/ioc';
import type { CaseDataProvider } from '../CaseDataProvider';
import type { IBackwardCompatibilityHandler } from './CasePersistenceHub';
import type { IStateMetadata } from '@/engine/app/CasePhaseData/interfaces.ts';

export class ImagesGuidResolverCompatibilityHandler implements IBackwardCompatibilityHandler {
  private readonly _caseDataProvider: CaseDataProvider;

  public constructor() {
    this._caseDataProvider = iocContainer.get<CaseDataProvider>(TYPES.CaseDataProvider);
  }

  public async handleMetadata(metadata: unknown /*, version?: string*/): Promise<unknown> {
    const header = await this._caseDataProvider.getCaseHeader();
    // Images names restoring from MCSD
    const imagesNames: Map<string, string> = new Map();
    for (let i = 0, sz = header.imagesLength(); i < sz; ++i) {
      const image = header.images(i)!;
      const guid = image.guid()!;
      const name = image.label()!;
      imagesNames.set(guid, name);
    }
    // ImagesGuidResolver meta => CasePhaseData meta
    const metaIn = metadata as Array<{
      descriptor: string;
      guid: string;
    }>;
    const metaOut: IStateMetadata = {
      phaseKinds: metaIn.map((val) => {
        return {
          kind: val.descriptor,
          kindInfo: {
            phaseImports: [],
            activePhaseId: val.guid,
            availablePhases: [
              {
                id: val.guid,
                name: imagesNames.get(val.guid) ?? '',
                params: []
              }
            ],
            params: []
          }
        };
      }),
      phaseStates: []
    };
    return metaOut;
  }
}
